// extracted by mini-css-extract-plugin
module.exports = {"publishDate":"PublishDate-module--publishDate--3zF6M"};